module.exports = __webpack_public_path__ + "static/media/2021-sommerfest-schm.130cb584.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2021-sommerfest-schm.jpg
// module id = 79
// module chunks = 0